import { render, staticRenderFns } from "./Editar.vue?vue&type=template&id=053c2c6b&scoped=true"
import script from "./Editar.vue?vue&type=script&lang=js"
export * from "./Editar.vue?vue&type=script&lang=js"
import style0 from "./Editar.vue?vue&type=style&index=0&id=053c2c6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c2c6b",
  null
  
)

export default component.exports